/* eslint-disable no-bitwise */
import { AddressMeta } from "../../form/address-finder-input";

export enum CustomerFormQuestionTypes {
    None = 0,
    DatePicker = 1 << 0, // 0001 -- the bitshift is unnecessary, but done for consistency
    AddressFinder = 1 << 1, // 0010
    BankAccount = 1 << 2, // 0100
    FileUpload = 1 << 3, // 0101
}

interface HTMLElement {
    type: "html";
    html: string;
}

interface TextElement {
    type: "text";
    name: string;
    title: string;
    isRequired?: boolean;
    startWithNewLine?: boolean;
    placeHolder?: string;
    defaultValue?: string;
    readOnly?: boolean;
    validators?: { type: string }[];
    visibleIf?: string;
}

type Element = HTMLElement | TextElement;

interface BaseQuestion {
    name: string;
    title: string;
    isRequired?: boolean;
    startWithNewLine?: boolean;
    visibleIf?: string;
    validators?: {
        type: "expression" | "email";
        expression?: string;
        text?: string;
    }[];
}

interface TextQuestion extends BaseQuestion {
    type: "text" | "comment";
    placeHolder?: string;
    readOnly?: boolean;
    defaultValue?: string;
}

interface DateQuestion extends BaseQuestion {
    type: "datepicker";
    inputType: "date";
}

interface FileQuestion extends BaseQuestion {
    type: "file";
    storeDataAsText?: boolean;
    allowMultiple?: boolean;
    maxSize?: number;
    waitForUpload?: boolean;
}

interface AddressQuestion extends BaseQuestion {
    type: "addressfinder";
    defaultValue?: AddressMeta;
}

export interface RadioGroupChoice {
    text: string;
    value: string | number;
}

interface RadioGroupQuestion extends BaseQuestion {
    type: "radiogroup";
    choices: string[] | RadioGroupChoice[];
    colCount?: number;
}

interface SignatureQuestion extends BaseQuestion {
    type: "signaturepad";
    penColor: string;
    width: number;
}

interface BankAccountQuestion extends BaseQuestion {
    type: "bankaccount";
}

interface DropdownQuestion extends BaseQuestion {
    type: "dropdown";
    choices: string[] | RadioGroupChoice[];
}

interface HTMLQuestion extends BaseQuestion {
    type: "html";
    html: string;
}

type Question =
    | AddressQuestion
    | BankAccountQuestion
    | DateQuestion
    | DropdownQuestion
    | FileQuestion
    | RadioGroupQuestion
    | SignatureQuestion
    | TextQuestion
    | HTMLQuestion;

export interface PageConfig {
    name: string;
    title?: string;
    visibleIf?: string;
    elements?: Element[];
    questions?: Question[];
}

export interface SurveyConfig {
    pages: PageConfig[];
}
